import httpFactory from '@core/api/instance/http-factory';

const MINUTES = 60 * 1000;

const http = httpFactory({ baseURL: configurationURL.accounts.baseUrl });

export default http;

function _setLocalStorageItem(key, value) {
  // Note: using `localStorage` directly, instead of `storage.put`,
  // because `storage.put` wraps value with an object, e.g.: `{ val: 'id' }`.
  // Also: this value is used inside `mfe-shell` app,
  // to track whenever an account or user was switched.
  // More info: https://adjustcom.atlassian.net/browse/ADAPP-12703
  window.localStorage.setItem(key, value);
}

export const getCurrentAccount = ({ forceUpdate = false } = {}) =>
  http
    .get('/current_account', { throttle: 5 * MINUTES, forceUpdate })
    .then(resp => resp.data)
    .then(data => {
      _setLocalStorageItem('dashboard-core:current_account_id', String(data.id));
      return data;
    });

export const getCurrentUser = ({ forceUpdate = false } = {}) =>
  http
    .get('/current_user', { throttle: 5 * MINUTES, forceUpdate })
    .then(resp => resp.data)
    .then(data => {
      _setLocalStorageItem('dashboard-core:current_user_id', String(data.id));
      return data;
    });

export const getTerms = ({ forceUpdate = false } = {}) =>
  Promise.all([getCurrentUser(), http.get('/terms', { throttle: 60 * MINUTES, forceUpdate })]).then(resp => {
    const [user, terms] = resp;

    const conditions = {
      gdpr: true,
      ccpa: user.role === 'admin' || user.role === 'editor',
    };

    return terms.data.filter(term => conditions[term.term_name]);
  });

export const acceptTerms = token => http.post(`/terms/${token}/accept`).then(resp => resp.data);

export const rejectTerms = token => http.post(`/terms/${token}/reject`).then(resp => resp.data);

export const switchCurrentAccount = id => http.post(`/accounts/switch`, { account_id: id, skip_redirect: true });
